import React from "react";
import { Project } from "../../types/project";

interface ProjectCardProps {
  project: Project;
  index: number;
  extraClass?: string;
}

const ProjectCard: React.FC<ProjectCardProps> = (props) => {
  return (
    <a
      key={props.index}
      className={`rellax group ${props.extraClass || ""}`}
      data-rellax-mobile-speed="0"
      data-rellax-speed={props.project.speed}
      data-rellax-tablet-speed="0"
      data-rellax-xs-speed="0"
      href={props.project.href}
      target="_blank"
      rel="noreferrer"
      style={{
        transform: `translate3d(0px, ${
          props.index % 2 === 0 ? "0" : props.index % 3 === 0 ? "14" : "-7"
        }px, 0px)`,
      }}
    >
      <div className="relative before:absolute before:inset-0 before:origin-top before:bg-gradient-to-t before:from-black/5 before:opacity-50 before:backdrop-grayscale before:transition before:duration-500 group-hover:before:origin-bottom group-hover:before:scale-y-0">
        <img
          className="transition duration-500 object-contain width-full"
          src={props.project.imgSrc}
          alt={props.project.title}
        />
      </div>
      <div className="flex items-center justify-between p-4">
        <h3 className="text-2xl font-normal text-white">{props.project.title}</h3>
        <span className="h-max rounded-full border border-white/30 px-2 py-1 text-xs tracking-wider text-white">
          {props.project.category?.[0] || "General"}
        </span>
      </div>
    </a>
  );
};

export default ProjectCard;
